import React from "react";
import { useQuickSightClaudeCoworkBedrock} from "@/hooks/useClaudeCoworkBedrockReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsClaudeCoworkBedrockDashboard from "@/components/organisms/ClaudeCoworkBedrockDashboard";

function ClaudeCoworkBedrockReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightClaudeCoworkBedrock();

  return (
    <AWSReportsTemplate
      title="AWS Claude Cowork Bedrock"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsClaudeCoworkBedrockDashboard />
    </AWSReportsTemplate>
  );
}

export default ClaudeCoworkBedrockReports;
